<template>
  <div v-if="legalDocuments">
    <vs-row vs-justify="space-between">
      <h6 class="mt-6 mb-4">Legal document checkboxes</h6>
      <div
        @click="onAddNew"
        class="
          btn-add-new
          p-2
          mb-4
          mr-4
          rounded
          cursor-pointer
          flex
          items-center
          justify-center
          text-small
          font-small
          text-base text-primary
          border border-solid border-primary
        "
      >
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Add legal document</span>
      </div>
    </vs-row>

    <vs-row>
      <div
        v-for="(legalDocumentRef, idx) in venueDetails.legalDocuments"
        :key="idx"
      >
        <vs-col class="rolecard p-3">
          <vs-card>
            <div slot="header">
              <vs-row vs-justify="space-between">
                <h6>Checkbox {{ idx + 1 }}</h6>
                <div>
                  <feather-icon
                    icon="XIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="ml-2"
                    @click.stop="confirmDelete(idx)"
                  />
                </div>
              </vs-row>
            </div>
            <div>
              <vs-row>
                <vs-col vs-w="4">Legal doc:</vs-col>
                <vs-col vs-w="8"
                  ><i>{{
                    legalDocumentName(legalDocumentRef.legalDocumentId)
                  }}</i></vs-col
                >
              </vs-row>
              <vs-row>
                <vs-col vs-w="4">Checkbox text:</vs-col>
                <vs-col vs-w="8"
                  ><i>{{ legalDocumentRef.checkboxDescription }}</i></vs-col
                >
              </vs-row>
              <vs-row class="mt-4 mb-3">
                <vs-col vs-w="4">Required:</vs-col>
                <vs-col vs-w="8"
                  ><i>{{ legalDocumentRef.required | yesno }}</i></vs-col
                >
              </vs-row>
            </div>
            <!-- <div slot="footer">
            <vs-row vs-justify="flex-end">
              <vs-button type="gradient" color="danger" icon="favorite"></vs-button>
              <vs-button color="primary" icon="turned_in_not"></vs-button>
              <vs-button color="rgb(230,230,230)" color-text="rgb(50,50,50)" icon="settings"></vs-button>
            </vs-row>
          </div> -->
          </vs-card>
        </vs-col>
      </div>
    </vs-row>

    <vs-popup
      style="z-index: 99999"
      title="Add legal document"
      :active.sync="addLegalDocumentPopupActive"
      id="addRolePopup"
    >
      <div>
        <vs-row vs-w="12" class="mt-2">
          <vs-col vs-w="12">
            <p class="mb-2">Select legal document:</p>
            <vs-select class="mb-5 w-full" v-model="selectedLegalDocument">
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.name"
                v-for="(item, index) in legalDocuments"
              />
            </vs-select>
          </vs-col>
        </vs-row>

        <p class="mb-2">Checkbox text</p>
        <vs-input
          class="inputx w-full"
          placeholder="Eg. Du giver hermed samtykke til..."
          v-model="selectedLegalDocumentText"
        />

        <p class="mb-2 mt-2">Required</p>
        <vs-checkbox v-model="selectedLegalDocumentRequired"></vs-checkbox>
        <vs-button
          @click="addLegalDocument"
          class="mt-10"
          color="primary"
          type="filled"
          icon-pack="feather"
          icon="done"
        >
          Add
        </vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import * as _ from "lodash";

import { mapGetters } from "vuex";

export default {
  props: {
    venueDetails: Object,
  },
  components: {},
  data() {
    return {
      testdocs: ["hmm"],
      checkBoxState: true,
      selectedLegalDocumentRequired: false,
      selectedLegalDocument: null,
      selectedLegalDocumentText: "",
      addLegalDocumentPopupActive: false,
      toDeleteIdx: "",
    };
  },
  computed: {
    ...mapGetters({
      activeVenueDetails: "marcom/activeVenue",
      activeVenueSetups: "marcom/activeVenueSetups",
      legalDocuments: "legalDocuments/documents",
    }),
  },
  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("legalDocuments/getAll");
    this.$vs.loading.close();
  },

  methods: {
    legalDocumentName(id) {
      const doc = this.legalDocuments.find((e) => e.id === id);
      return doc ? doc.name : "No name";
    },
    async confirmDelete(id) {
      this.toDeleteIdx = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to remove document from venue setup?",
        accept: this.deleteLegalDocument,
      });
    },
    deleteLegalDocument() {
      this.venueDetails.legalDocuments.splice(this.toDeleteIdx, 1);
    },
    addLegalDocument() {
      this.venueDetails.legalDocuments.push({
        required: this.selectedLegalDocumentRequired,
        legalDocumentId: this.selectedLegalDocument,
        checkboxDescription: this.selectedLegalDocumentText,
      });
      this.addLegalDocumentPopupActive = false;
    },
    onAddNew() {
      this.selectedLegalDocument = "";
      this.selectedLegalDocumentText = "";
      this.addLegalDocumentPopupActive = true;
    },
  },
};
</script>



<style lang="scss">
.vs-select--options {
  z-index: 99999999 !important;
}
#addRolePopup.con-vs-popup .vs-popup {
  width: 940px !important;
  max-width: 80vw !important;
}

.role-table {
  max-height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.rolecard {
  &.deactivated {
    opacity: 0.75;
  }

  min-width: 380px;
  max-width: 380px;

  .con-vs-card {
    border: 2px solid #ccc;
  }

  .vs-card--content {
    margin-bottom: 0;
  }

  .vs-card--footer {
    padding: 6px 12px;
    margin-top: 0;
    transform: none;
    background-color: #ccc;
    font-size: 0.8rem;
  }
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
